"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'userGroup.form.title.edit': 'Edytuj Grupę Użytkowników',
    'userGroup.form.title.add': 'Dodaj Grupę Użytkowników',
    'userGroup.form.back': 'Wstecz',
    'userGroup.form.name.label': 'Nazwa Grupy',
    'userGroup.form.name.placeholder': 'Wprowadź nazwę grupy',
    'userGroup.form.description.label': 'Opis',
    'userGroup.form.description.placeholder': 'Wprowadź opis grupy',
    'userGroup.form.active.label': 'Aktywna',
    'userGroup.form.acl.label': 'Kontrola Dostępu',
    'userGroup.form.acl.description': 'Skonfiguruj uprawnienia dostępu dla tej grupy użytkowników',
    'userGroup.form.submit.update': 'Aktualizuj Grupę Użytkowników',
    'userGroup.form.submit.create': 'Utwórz Grupę Użytkowników',
    'userGroup.form.saved': 'Grupa użytkowników została pomyślnie zapisana',
    'userGroup.form.error.save': 'Błąd podczas zapisywania grupy użytkowników',
};
